import { makeEntityScaffold } from '@classpass/saga-tools';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noGiftCode: {
    id: 'purchase.addGiftCode.noGiftCode',
    defaultMessage: 'Please enter your gift code to redeem.',
  },
});

export const createGift = makeEntityScaffold(
  'SAGA.API.CREATE_GIFT',
  (
    client,
    paymentToken,
    msaId,
    giftAmount,
    giftMessage,
    senderEmail,
    senderName,
    deliveryDate,
    recipientEmail,
    recipientName,
    conversion
  ) => {
    const payload = {
      gift_amount: parseFloat(giftAmount),
      payment_token: paymentToken,
      msa_id: parseInt(msaId, 10),
      delivery_date: deliveryDate,
      message: giftMessage,
      gifter: { name: senderName, email: senderEmail },
      recipient: { name: recipientName, email: recipientEmail },
    };

    if (conversion) {
      payload.conversion = conversion;
    }

    return client.gifts.create(payload);
  }
);

export const verifyGift = makeEntityScaffold('SAGA.API.VERIFY_GIFT', (client, userId, msaId, giftCode) => {
  if (giftCode) {
    return client.gifts
      .getUserGifts(userId, {
        msa_id: msaId,
        redemption_code: giftCode,
      })
      .then(data => (data && data.gifts && data.gifts.length ? data.gifts[0] : null));
  }

  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject({ message: messages.noGiftCode });
});
